import { reducedDimensions } from './reducedDimensions.js';
function largestAxis(dimensions) {
    let axis = 0;
    for (let other = 1; other < 3; other++) {
        if (dimensions[other] > dimensions[axis]) {
            axis = other;
        }
    }
    return axis;
}
function boxAverageReductionFactors(dimensions, limits) {
    const factors = [1, 1, 1];
    const { maxEdge, maxVoxelCount } = limits ?? {};
    if (maxEdge > 0) {
        for (let axis = 0; axis < 3; axis++) {
            factors[axis] = Math.max(1, Math.ceil(dimensions[axis] / maxEdge));
        }
    }
    if (!(maxVoxelCount > 0)) {
        return factors;
    }
    let reduced = reducedDimensions(dimensions, factors);
    while (reduced[0] * reduced[1] * reduced[2] > maxVoxelCount) {
        const axis = largestAxis(reduced);
        if (reduced[axis] <= 1) {
            break;
        }
        factors[axis] += 1;
        reduced = reducedDimensions(dimensions, factors);
    }
    return factors;
}
export { boxAverageReductionFactors as default, boxAverageReductionFactors, largestAxis, };
